import { BinaryWriter, utils } from '@neo-one/client-common';
import { BooleanContractParameter } from '@neo-one/node-core';
import { StackItemBase } from './StackItemBase';
import { StackItemType } from './StackItemType';
export class BooleanStackItem extends StackItemBase {
    constructor(value) {
        super();
        this.value = value;
    }
    asBigInteger() {
        return this.value ? utils.ONE : utils.ZERO;
    }
    asBoolean() {
        return this.value;
    }
    asBuffer() {
        return this.value ? BooleanStackItem.TRUE : BooleanStackItem.FALSE;
    }
    toContractParameter(_seen = new Set()) {
        return new BooleanContractParameter(this.value);
    }
    serializeInternal() {
        const writer = new BinaryWriter();
        writer.writeUInt8(StackItemType.Boolean);
        writer.writeBoolean(this.value);
        return writer.toBuffer();
    }
}
BooleanStackItem.TRUE = Buffer.from([1]);
BooleanStackItem.FALSE = Buffer.from([]);

//# sourceMappingURL=BooleanStackItem.js.map
